export default "__VITE_ASSET__KU9XaBw8__"